// =================================
// Routes for public registration form to be injected into wordpress site
// ================================= 
const REGISTRATION = "/registration";
const SESSIONS = "/sessions";
const PAYMENT = "/payment"; 
const REGISTRATION_FORMS = "/:formDefinitionCode";

export const RegistrationRoutes = {
    REGISTRATION,
    SESSIONS,
    PAYMENT,
    REGISTRATION_FORMS
}

const CONTENT_HOME = "https://www.bct2026.org/"

export const PublicRoutes = {
    CONTENT_HOME
}


// =================================
// Routes Early Bird Registration
// =================================
const EARLY_BIRD_REGISTRATION = "/early-bird/:guid";

export const EarlyBirdRegistrationRoutes = {
    EARLY_BIRD_REGISTRATION
}

// =================================
// Routes for conference admin site
// =================================
const HOME = "/admin";
const LOGOUT = "/auth/logout";
const FORBIDDEN = "/forbidden";
const HANGFIRE = "/hangfire";
const ADMIN_BASE = "/admin";
const ADMIN_REGISTRATION = "/admin/registration";
const ADMIN_REGISTRATION_BY_ID = "/admin/registration/:id";
const ADMIN_FORMS_BY_ID = "/admin-form/:formDefinitionCode/:id";
const ADMIN_EARLY_BIRD = "/admin/early-birds";
const ADMIN_FORMS = "/admin-form/:formDefinitionCode";
const ADMIN_REGISTRATIONS = "/admin/registration-desk";
const ADMIN_REPORTS = "/admin/reports";
const ADMIN_SESSIONS = "/admin/sessions";
const ADMIN_SESSION_BY_ID = "/admin/session/:id";
const ADMIN_SESSION = "/admin/session";
const ADMIN_INVOICE_BY_ID = "/admin/invoice/:registrationId";
const ADMIN_CERTIFICATES = "/admin/certificates";
const ADMIN_SPONSOR = "/admin/sponsor";
const ADMIN_ADD_SPONSOR = "/admin/addSponsor";
const ADMIN_SPONSOR_BY_ID = "/admin/addSponsor/:id";
const ADMIN_SPEAKER = "/admin/custom-registrations";
const ADMIN_ADD_SPEAKER = "/admin/add-custom-registration";
const ADMIN_SPEAKER_BY_ID = "/admin/custom-registration/:id";
const SPONSOR = "/sponsor";
const ADMIN_PRINTING = "/admin/badge-printing";

export const AdminRoutes = {
    HOME,
    LOGOUT,
    FORBIDDEN,
    HANGFIRE,
    ADMIN_BASE,
    ADMIN_REGISTRATION,
    ADMIN_REGISTRATION_BY_ID,
    ADMIN_FORMS,
    ADMIN_FORMS_BY_ID,
    ADMIN_REGISTRATIONS,
    ADMIN_REPORTS,
    ADMIN_SESSIONS,
    ADMIN_SESSION,
    ADMIN_SESSION_BY_ID,
    ADMIN_INVOICE_BY_ID,
    ADMIN_CERTIFICATES,
    ADMIN_SPONSOR,
    ADMIN_ADD_SPONSOR,
    ADMIN_SPONSOR_BY_ID,
    ADMIN_SPEAKER,
    ADMIN_ADD_SPEAKER,
    ADMIN_SPEAKER_BY_ID,
    SPONSOR,
    ADMIN_EARLY_BIRD,
    ADMIN_PRINTING
}